import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Membership } from '../models/membership.model';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.connect}/${globals.MEMBERSHIPS}`;

@Injectable({
  providedIn: 'root',
})

export class MembershipsService {
  constructor(
    private http: HttpClient) {
  }

  getMemberships(account_id: number): Observable<Membership[]> {
    return this.http.get<Membership[]>(`${baseUrl}/${globals.GET_MEMBERSHIPS}/${account_id}`);
  }

  addMembership(data: any): Observable<boolean> {
    return this.http.post<boolean>(`${baseUrl}/${globals.ADD_MEMBERSHIP}`, data);
  }

  deleteMembership(account_id: number, member_email: string): Observable<boolean> {
    return this.http.delete<boolean>(`${baseUrl}/${globals.REMOVE_MEMBERSHIP}/${account_id}?email_id=${member_email}`);
  }
}
